import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplatePrintRequestId = Brand<number, 'MediaTemplatePrintRequestId'>;
export const MediaTemplatePrintRequestId = createBranded<MediaTemplatePrintRequestId>();
